import api from "@/services/api";

const { post, put, get, delete: del } = api.getPrefixedMethods("orderinfo");

export const orderInfoService = {
  submitOrderInfo(data) {
    return post("", data);
  },
  validateAccess(data) {
    return post("access-initiated-prior-auth", data);
  },
  getListOfOrders(index, status, patient, date, dateFrom, dateTo, orderBy, tags, pageSize, modifiedBy) {
    const params = { page: index, status };
    if (patient) params.patient = patient;
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    if (!dateFrom && !dateTo && date) params.date = date;
    if (orderBy) params.order_by = orderBy;
    if (tags) params.tags = tags;
    if (pageSize) params.page_size = pageSize;
    if (modifiedBy) params.modified_by = modifiedBy;
    return get("", { params });
  },
  getOrderStatusCounts(filters = {}) {
    const params = {};
    if (filters.dateFrom) params.date_from = filters.dateFrom;
    if (filters.dateTo) params.date_to = filters.dateTo;
    return get("submission-counts", { params });
  },
  uploadDecisionDocument(orderKey, data) {
    return put(`upload-decision-document/${orderKey}`, data);
  },
  changeOrderFormulary(orderKey, data) {
    return put(`change-order-formulary/${orderKey}`, data);
  },
  changeFormSelection(orderKey, data) {
    return put(`change-form-selection/${orderKey}`, data);
  },
  reopenSubmission(orderKey, data) {
    return put(`reopen-submission/${orderKey}`, data);
  },
  searchOrders(searchTerm, index, pageSize) {
    const params = { page: index };
    if (pageSize) params.page_size = pageSize;
    return post("search", searchTerm, { params });
  },
  getOrderDetails(id) {
    return get(`submission/${id}`);
  },
  getOrderAuditLogs(orderKey, pagingOptions) {
    return get(`submission/${orderKey}/audits`, { params: pagingOptions });
  },
  startOrderStaffTime(documentKey) {
    return post(`submission/${documentKey}/staff-time`);
  },
  pushOrderStaffTime(documentKey) {
    return del(`submission/${documentKey}/staff-time`);
  },
  pullAutofillingData(orderKey, data) {
    return post(`submit-autofill-data/${orderKey}`, data);
  },
  getAvailableAddressBooks() {
    return get("available-address-books");
  },
  createEmptyBenefitVerificationRequest(data) {
    return post("create-benefit-verification", data);
  },
  saveBenefitVerificationRequest(orderKey, data) {
    return put(`save-benefit-verification/${orderKey}`, data);
  },
  createEmptyOrder(data) {
    return post("create-empty-order", data);
  },
  createNewOrder(data) {
    return post("create-order", data);
  },
  saveOrder(orderKey, data) {
    return put(`save-order/${orderKey}`, data);
  },
  submitPdfForm(data) {
    return post("pdf-submission", data);
  },
  getPdfSubmissionDetails(id) {
    return get(`pdf-submission/${id}`);
  },
  updatePdfSubmission(id, data) {
    return put(`pdf-submission/${id}`, data);
  },
  fetchPatientRecords(orderKey) {
    return get(`patient-records/${orderKey}`);
  },
  deleteOrder(orderKey) {
    return del(`submission/${orderKey}`);
  },
  getSupportingDocumentsPdf(orderKey) {
    return get(`supporting-documents-pdf/${orderKey}`, {
      responseType: "blob",
      headers: { "Content-Type": "application/pdf" },
      _returnFullResponse: true,
      _skipPropsAdaptation: true,
    });
  },
  getFilledFormPdf(orderKey) {
    return get(`filled-form-pdf/${orderKey}`, {
      responseType: "blob",
      headers: { "Content-Type": "application/pdf" },
      _returnFullResponse: true,
      _skipPropsAdaptation: true,
    });
  },
  archiveOrder(orderKey) {
    return put(`submission/${orderKey}/archive/`);
  },
  unarchiveOrder(orderKey) {
    return del(`submission/${orderKey}/archive/`);
  },
  changeSubmissionMethod(orderKey, data) {
    return put(`submission/${orderKey}/change-submission-method/`, data);
  },
  changeRecordedStatus(orderKey, data) {
    return put(`submission/${orderKey}/change-recorded-status/`, data);
  },
  sendToPrescriber(orderKey, data) {
    return post(`send-to-prescriber/${orderKey}/`, data);
  },
  importCMMSubmission(data) {
    return post("cmm-submissions/", data);
  },
  updateSubmissionTags(orderKey, tags) {
    return put(`submission/${orderKey}/tags/`, { tags });
  },
  acquireOrderLock(orderKey) {
    return post(`submission/${orderKey}/locks/`);
  },
  releaseOrderLock(orderKey) {
    return del(`submission/${orderKey}/locks/`);
  },
};
